import $ from "jquery";
import i18n from "utils/i18n";
import PropTypes from "prop-types";
import React from "react";
import SimpleStorage from "utils/simple-storage";

/**
 * A widget for notifying users that there will be downtime on a specific date.
 *
 * @example
 *   <DowntimeNotification
 *     epochTime={1558854300}
 *     message="Simple In/Out will be down for maintenance"
 *     title="Scheduled Maintenance"
 *     url="https://www.simplymadeapps.com/"
 *   />
 */
class DowntimeNotification extends React.Component {
  /**
   * Creates the component with the initial state based on props.
   *
   * @param {object} props Initial props
   */
  constructor(props) {
    super(props);
    this.state = { showBadge: false };
    this.onClick = this.onClick.bind(this);
  }

  /**
   * Determines whether the badge should be shown and activates the Bootstrap popover.
   */
  componentDidMount() {
    this.determineBadgeVisibility();

    $(this.refs.bell).popover({
      content: this.renderMessage(),
      html: true,
      placement: "bottom",
      title: this.props.title
    });
  }

  /**
   * Shows the red badge on the bell icon if the user has never dismissed this notification.
   */
  determineBadgeVisibility() {
    const dismissedNotification = parseInt(SimpleStorage.getItem("dismissedDowntimeNotification"));

    if (isNaN(dismissedNotification) || dismissedNotification !== this.props.epochTime) {
      this.setState({ showBadge: true });
    }
  }

  /**
   * Hides the badge and saves that the user dismissed the notification to storage
   * so the badge doesn't show the next time the page is loaded.
   */
  onClick() {
    this.setState({ showBadge: false });
    SimpleStorage.setItem("dismissedDowntimeNotification", this.props.epochTime);
  }

  /**
   * Render the notification bell with or without the badge.
   *
   * @returns {object} The React element
   */
  render() {
    return (
      <a className="btn btn-link" onClick={this.onClick} ref="bell">
        <i className="fa fa-bell">{this.state.showBadge ? <span className="downtime-notification-badge" /> : null}</i>
      </a>
    );
  }

  /**
   * Returns the HTML used as the message for the Bootstrap popover.
   *
   * @returns {string} The popover message HTML
   */
  renderMessage() {
    return (
      '<div class="downtime-notification-message">' +
      this.props.message +
      ` <a href="${this.props.url}" target="_blank">${i18n.t("manager.learn_more")}</a>` +
      "</div>"
    );
  }
}

DowntimeNotification.propTypes = {
  epochTime: PropTypes.number.isRequired,
  message: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};

export default DowntimeNotification;
